import { h, Fragment } from 'preact'
import { IPurchaseOrderHtml } from './types'
import { isObject } from 'lodash'

export const TmpOrderNoteBill = ({
  order,
  option: { include_note },
}: {
  order: IPurchaseOrderHtml.Order
  option: IPurchaseOrderHtml.Option
  disable_note?: boolean
}) => (
  
  
  <Fragment>
    <div class="">
      <div class="order-note page-slip border-top text-small ">
        <p>
          หมายเหตุลูกค้า : {order.customer_note || '-'}
        </p>
      </div>
      {include_note && (
        <div class="order-note page-slip px-0 text-small mt-2">
          <p>
           หมายเหตุภายใน : {order.note || '-'}
          </p>
        </div>
      )}
    </div>
    <div class="page-slip thk text-small">
      <div>ชำระโดย : ช่องทาง {isObject(order.paymenttype) ? order.paymenttype.name : '-'}</div>
      <div>**THANK YOU**</div>
    </div>
  </Fragment>

)
